import Vue from "vue";
import Vuex from "vuex";
import config from "@/utils/config.js";
import questionType from "./modules/questionType.js";
import moduleQuestionnaire from "./modules/moduleQuestionnaire.js";
import moduleExam from "./modules/moduleExam.js";
import moduleEvaluation from "./modules/moduleEvaluation.js";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    appId: config.appId, //问卷加加
  },
  mutations: {},
  actions: {
    setAppId({ commit }, appId) {
      commit("setAppId", appId);
    },
  },
  getters: {
    getAppId: (state) => state.appId,
  },
  modules: {
    questionType,
    moduleQuestionnaire,
    moduleExam,
    moduleEvaluation,
  },
});



// WEBPACK FOOTER //
// ./src/store/index.js